<script setup lang="ts">
interface IDateFormated {
    startDate: string;
    endDate: string;
    icon?: string;
    iconBefore?: string;
    size?: "md" | "sm";
    dateQuantity?: number;
}

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = withDefaults(defineProps<IDateFormated>(), {
    size: "sm",
});
</script>
<template>
    <div class="dateFormated">
        <i v-if="iconBefore" :class="`ti ti-${iconBefore}`"></i>
        <div :class="['date', size]">
            {{ startDate }}
            <i :class="`ti ti-${icon}`"></i>
            {{ endDate }}
            {{ dateQuantity && dateQuantity > 1 ? ` +${(dateQuantity - 1)}` : "" }}
        </div>
    </div>
</template>
<style scoped lang="scss">
.dateFormated {
    gap: 6px;
    display: flex;
    align-items: baseline;
    .date {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        font-weight: 400;
        color: $text-main-900;
        .ti {
            font-size: 14px;
            color: $icon-soft-400;
        }

        &.md {
            font-size: 13px;
            font-weight: 500;
        }
    }
}
</style>
